<!--
 * @Author: mzw
 * @Date: 2021-09-22 15:13:50
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-09-12 14:36:51
 * @Description: 地址编辑弹窗组件
-->
<template>
  <el-dialog
    title="修改收货地址"
    :visible.sync="editAddressVisible"
    width="680px"
    :before-close="handleClose2"
    :close-on-click-modal="false"
  >
    <div class="addArea" v-if="editAddressInfo">
      <div class="add_form">
        <el-form
          ref="editAddressInfo"
          label-width="110px"
          :model="editAddressInfo"
          :rules="addressRule"
          :disabled="buttonLoading"
          label-position="right"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="收货人：" prop="receiveGoodsPerson">
                <el-input
                  v-model="editAddressInfo.receiveGoodsPerson"
                  placeholder="请输入收货人姓名"
                  :maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="联系电话：" prop="receiveGoodsPhone">
                <el-input
                  v-model="editAddressInfo.receiveGoodsPhone"
                  placeholder="支持座机号码录入"
                  :maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="所属区域：" prop="proCityArea">
            <el-cascader
              :options="region"
              clearable
              :placeholder="
                (editAddressInfo.proCityArea &&
                  editAddressInfo.proCityArea.join(' / ')) ||
                '请选择'
              "
              :props="props"
              v-model="editAddressInfo.proCityArea"
              style="width: 100%"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input
              v-model="editAddressInfo.address"
              placeholder="请输入详细地址"
              :maxlength="200"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="是否为默认：">
                    <el-checkbox v-model="editAddressInfo.defaultAddress" text-color="#333333" fill="#1D65A8" class="defaultbox">
                        默认收货地址
                    </el-checkbox>
                </el-form-item> -->
        </el-form>
        <div
          @click="handleAddressSaved"
          class="saveAdd"
          v-loading="buttonLoading"
        >
          {{ $t("order.submit") }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import validate from '@/utils/validate'
export default {
  data () {
    return {
      region: [],
      props: {
        label: 'name',
        value: 'name',
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node
          // 防止过载
          if (node.loaded) {
            resolve([])
            return
          }
          if (level === 1) {
            // 切换省
            this.getCity(data.codeP)
              .then((res) => {
                resolve(res)
              })
              .catch(() => {
                resolve([])
              })
          }
          if (level === 2) {
            // 切换市
            this.getArea(data.codeC)
              .then((res) => {
                resolve(res)
              })
              .catch(() => {
                resolve([])
              })
          }
        }
      }
    }
  },
  props: {
    editAddressInfo: {
      type: Object,
      default: null
    },
    editAddressVisible: {
      type: Boolean,
      default: false
    },
    buttonLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogTitle () {
      return this.editAddressInfo && this.editAddressInfo.userAddressId
        ? this.$t('order.updateNewAddress')
        : this.$t('order.addNewAddress')
    },
    addressRule () {
      return {
        proCityArea: [
          {
            required: true,
            type: 'array',
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        receiveGoodsPerson: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        receiveGoodsPhone: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          },
          {
            validator: validate.validatePhoneTwo,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleClose2 () {
      this.$emit('handleClose2')
    },
    handleAddressSaved () {
      this.$refs['editAddressInfo'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$emit('handleAddressSaved')
      })
    },
    // 获取省
    getProvince () {
      this.$http
        .get(`/front/sys/sysProvince/provinceList`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.region = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取省份失败')
        })
    },
    // 获取市
    getCity (codeP) {
      return this.$http
        .get(`/front/sys/sysProvince/cityList/${codeP}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            return res.data
          } else {
            this.$message.error(res.msg)
            return []
          }
        })
        .catch(() => {
          this.$message.error('获取城市失败')
        })
    },
    // 获取区
    getArea (codeC) {
      return this.$http
        .get(`/front/sys/sysProvince/areaList/${codeC}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            const leafData = res.data.map((item) => {
              return {
                ...item,
                leaf: true
              }
            })
            return leafData
          } else {
            this.$message.error(res.msg)
            return []
          }
        })
        .catch(() => {
          this.$message.error('获取区域失败')
        })
    }
  },
  mounted () {
    this.getProvince()
  }
}
</script>
<style lang='scss' scoped>
@import "../common/dialogStyle.scss";
</style>
